<template>
  <Layout>
    <div class="CounterUpPage daraagent">
      <div class="CounterUpPage_content">
        <div class="staticBanner" v-for="(item, index) in Bannerlist[val - 1]" :key="index">
          <img class="img-bg" :src="item.bg" alt="" />
          <div class="text color-white" data-aos="fade-up">
            <h4 class="staticimg-title color-white fs-1">{{ item.title }}</h4>
            <div class="staticimg-content fs-3">{{ item.title2 }}</div>
            <div class="input-btn">
              <input class="input" type="text" placeholder="请输入您的手机号码" />
              <button class="free-btn btn" @click="orderShow">免费试用</button>
            </div>
            <div class="scroll">
              <div class="fs-3">500+ 大型集团企业共同选择</div>
              <div class="company animate__animated">
                <vue-seamless-scroll :data="companyall" :class-option="defaultOption">
                  <div class="companymain">
                    <div class="companyitem" v-for="(log, j) in companyall">
                      <img class="logoimg" :src="log.logo" alt="" />
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
        <dropdownMenu :pkname="'博信诚AI元生平台'" @func="title" :type="val" :pktype="'dataAgent'"></dropdownMenu>
        <div class="titles" v-if="windowWidth > 767">
          <div class="in_titles">
            <div class="in_titles_left">
              <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="" />
              <div><span style="margin-right: 10px">&gt;</span><span style="font-size: 18px">博信诚AI元生平台</span></div>
            </div>
            <div class="in_titles_right">
              <a :class="val == '1' ? 'changes' : ''" @click="goTitle('1')">AI元生平台</a>
              <a :class="val == '2' ? 'changes' : ''" @click="goTitle('2')">元生|DataAgent</a>
              <a :class="val == '3' ? 'changes' : ''" @click="goTitle('3')">AI审核</a>
              <a :class="val == '4' ? 'changes' : ''" @click="goTitle('4')">AI合同审核</a>
              <a :class="val == '5' ? 'changes' : ''" @click="goTitle('5')">AI智慧网银</a>
              <a :class="val == '6' ? 'changes' : ''" @click="goTitle('6')">AI报账</a>
              <!-- <a :class="val == '7' ? 'changes' : ''" @click="goTitle('6')">AI知识库</a>
                <a :class="val == '8' ? 'changes' : ''" @click="goTitle('7')">AI智能客服</a>
                <a :class="val == '9' ? 'changes' : ''" @click="goTitle('8')">AI智能体定制</a> -->
            </div>
          </div>
        </div>
        <div class="content_body container">
          <div class="group_mid" v-for="(item, index) in groupData[val - 1]" :key="index">
            <div class="mid_top rn-section-gap" data-aos="fade-up">
              <h3 class="mid_top_title fs-1 text-center">{{ item.topTitle }}</h3>
              <div class="fs-3 text-center lyd-title-colo1">{{ item.text }}</div>
              <div class="fs-3 text-center lyd-title-colo1">{{ item.text2 }}</div>
            </div>
            <div class="mid_bot">
              <img :src="item.img1" alt="" style="margin-bottom: 3rem" />
            </div>
          </div>
        </div>
        <!-- <div class="model">
					<ModelBox :val="val" :claWidth="claWidth" :modelBox="modelBox" :showButton="false"
						:mainTitle="titleList[val].mainTitle" :subTitle="titleList[val].subTitle"></ModelBox>
				</div> -->

        <!-- 核心优势 -->
        <div class="" v-if="val == '1'">
          <FeatureCards
            :cards="modelBox[val - 1]"
            :columnsPerRow="4"
            :showTitle="true"
            :showMainTitle="true"
            :showSubTitle="true"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            cardGap="20px"
            cardHeight="280px"
            :defaultBackground="require('@/assets/images/dataAgent/核心优势_bj_image@2x.jpg')"
          />
        </div>
        <!-- 核心价值 -->
        <div class="hxjzmodel" v-if="val == '2'">
          <FeatureCards
            :cards="modelBox[val - 1]"
            :columnsPerRow="4"
            :showTitle="true"
            :showMainTitle="true"
            :showSubTitle="true"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            cardGap="20px"
            cardHeight="280px"
            :defaultBackground="require('@/assets/images/dataAgent/核心优势_bj_image@2x.jpg')"
          />
          <!-- <ModelBox
            key="hxjz"
            :uniqueId="'hxjz'"
            :val="1"
            :claWidth="claWidth"
            :modelBox="modelBox1"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showButton="false"
            :enableImageScale="false"
            :backgroundImage="require('@/assets/images/EcoAIBigData/hexingongneng_bj_image@2x.jpg')"
          >
          </ModelBox> -->
        </div>
        <!-- 独特优势 -->
        <div class="dtysmodel" v-if="val == '2' && false">
          <ModelBox
            key="dtys"
            :uniqueId="'dtys'"
            :val="1"
            :claWidth="claWidth"
            :modelBox="modelBox2"
            mainTitle="独特优势"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showButton="false"
            :enableImageScale="false"
            :backgroundImage="require('@/assets/images/EcoAIBigData/hexinyoushi_bj_image@2x.jpg')"
          >
          </ModelBox>
        </div>
        <div class="dataAgentDiv" v-if="val == '2'">
          <div class="container">
            <div class="fs-1 fw-bold text-center mt-lyd-70">产品展示</div>
            <div class="fs-3 text-center subjtitle lyd-title-colo1">{{ Bannerlist[val - 1][0].title2 }}</div>
          </div>
          <div class="dataAgent-cont container">
            <div class="dataAgentItem" v-for="(item, index) in dataList" :key="index">
              <div class="dataAgent-top">
                <div class="dataAgentIcon">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="dataAgentTitle">{{ item.title }}</div>
                <div class="dataAgentTitle">{{ item.description }}</div>
                <div class="dataAgentBtn">立即体验</div>
              </div>
              <div class="dataAgentImg">
                <img :src="item.backgroundImage" alt="" class="animate__animated" data-aos="zoom-in-up" data-aos-delay="300" />
              </div>
            </div>
          </div>
        </div>
        <!-- 产品展示	 -->
        <div v-if="val == '1'" class="product-display-bg">
          <div class="container">
            <div class="fs-1 fw-bold text-center mt-lyd-70">产品展示</div>
            <div class="fs-3 text-center subjtitle lyd-title-colo1">{{ Bannerlist[val - 1][0].title2 }}</div>
            <div class="fs-3 text-center subjtitleth lyd-title-colo1">
              博信诚AI元生平台与先进的行业reference应用场景深度融入形成了AI助手、AI报账、AI审核、AI分析、AI合规、AI资金预测、AI流程效能评估等
              200多个Agent为客户提供多行业、全场景的各类智能化应用服务，并帅先予以落地实践。
            </div>

            <div class="product-showcase-container">
              <img src="@/assets/images/dataAgent/产品截图_image@2x.png" alt="产品截图" class="main-product-image" />
              <img
                src="@/assets/images/dataAgent/3.AI审核_悬浮窗_image@2x.png"
                alt="AI审核"
                class="floating-window ai-audit animate__animated"
                data-aos="zoom-in-up"
                data-aos-delay="100"
              />
              <img
                src="@/assets/images/dataAgent/2.AI工作助理_悬浮窗_image@2x.png"
                alt="AI工作助理"
                class="floating-window ai-assistant animate__animated"
                data-aos="zoom-in-up"
                data-aos-delay="200"
              />
              <img
                src="@/assets/images/dataAgent/1.AI报账_悬浮窗_image@2x.png"
                alt="AI报账"
                class="floating-window ai-reimbursement animate__animated"
                data-aos="zoom-in-up"
                data-aos-delay="300"
              />
            </div>
          </div>
        </div>
        <!-- Deepseek+企业级AI元生平台，多样化的应用部署模式 -->
        <div v-if="val == '1'">
          <DeepseekRemoteDeploy
            :deploy-data="deployData"
            mainTitle="Deepseek+企业级AI元生平台，多样化的应用部署模式"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showTitle="true"
          ></DeepseekRemoteDeploy>
        </div>

        <!-- ai 审核核心功能 -->
        <div class="" v-if="val == '3'">
          <FeatureCards
            :cards="modelBox[val - 1]"
            :columnsPerRow="columnsPerRowList[val - 1]"
            :showTitle="true"
            :showMainTitle="true"
            :showSubTitle="true"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            cardGap="20px"
            cardHeight="280px"
            :defaultBackground="require('@/assets/images/dataAgent/核心优势_bj_image@2x.jpg')"
          />
        </div>
        <!-- 产品展示	 -->
        <div v-if="val == '3'" class="product-display-bg" style="top: 0">
          <div class="container">
            <div class="fs-1 fw-bold text-center mt-lyd-70">产品展示</div>
            <div class="fs-3 text-center lyd-title-colo1 subjtitle">{{ Bannerlist[val - 1][0].title2 }}</div>

            <div class="product-showcase-container">
              <img src="@/assets/images/dataAgent/AI审核_image@2x.png" class="aishenhe animate__animated" alt="AI审核" data-aos="fade-pulse" />
            </div>
          </div>
        </div>
        <!-- 核心优势 -->
        <div class="dtysmodel" v-if="val == '3'">
          <ModelBox
            key="hxys"
            :uniqueId="'hxys'"
            :val="1"
            :claWidth="claWidth"
            :modelBox="modelBox3"
            mainTitle="核心优势"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showButton="false"
            :enableImageScale="false"
            :backgroundImage="require('@/assets/images/EcoAIBigData/hexinyoushi_bj_image@2x.jpg')"
          >
          </ModelBox>
        </div>

        <!-- ai合同审核 -->
        <div v-if="val == '4'" class="product-display-bg" style="top: 0">
          <div class="container pcdsflex">
            <div data-aos="fade-right" data-aos-delay="100">
              <div class="fs-1 fw-bold" data-aos="fade-up" data-aos-delay="200">智能风险评估</div>
              <div class="fs-3 subjtitle" data-aos="fade-up" data-aos-delay="300">
                快速扫描并分析合同条款，自动识别潜在风险。根据预设标准对合同进行风险评分，帮助用户直观了解合同的安全性。
              </div>
            </div>

            <div class="product-showcase-container">
              <img
                src="@/assets/images/dataAgent/智能风险评估_产品截图_image@2x.png"
                class="animate__animated"
                alt="智能风险评估"
                data-aos="zoom-in-left"
                data-aos-delay="400"
              />
            </div>
          </div>
        </div>
        <div v-if="val == '4'" class="product-display-bg" style="top: 0">
          <div class="container pcdsflex">
            <div class="product-showcase-container">
              <img
                src="@/assets/images/dataAgent/关键条款检测_产品截图_image@2x.png"
                class="animate__animated"
                alt="关键条款检测"
                data-aos="zoom-in-right"
                data-aos-delay="100"
              />
            </div>
            <div data-aos="fade-left" data-aos-delay="200">
              <div class="fs-1 fw-bold" data-aos="fade-up" data-aos-delay="300">关键条款检测</div>
              <div class="fs-3 subjtitle" data-aos="fade-up" data-aos-delay="400">
                检查合同有效期、续签条件等关键信息是否明确无误确保付款时间节点合理，保护双方利益。
              </div>
            </div>
          </div>
        </div>
        <div v-if="val == '4'" class="product-display-bg" style="top: 0">
          <div class="container pcdsflex">
            <div data-aos="fade-right" data-aos-delay="100">
              <div class="fs-1 fw-bold" data-aos="fade-up" data-aos-delay="200">提供优化建议</div>
              <div class="fs-3 subjtitle" data-aos="fade-up" data-aos-delay="300">
                针对发现的问题，提供具体的修改建议和最佳实践指导，利用过往审核数据为用户提供更加精准的建议。
              </div>
            </div>

            <div class="product-showcase-container">
              <img
                src="@/assets/images/dataAgent/智能风险评估2_产品截图_image@2x.png"
                class="animate__animated"
                alt="智能风险评估"
                data-aos="zoom-in-left"
                data-aos-delay="400"
              />
            </div>
          </div>
        </div>
        <div class="" v-if="val == '4'">
          <FeatureCards
            :cards="modelBox[val - 1]"
            :columnsPerRow="columnsPerRowList[val - 1]"
            :showTitle="true"
            :showMainTitle="true"
            :showSubTitle="true"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            cardGap="20px"
            cardHeight="280px"
            :defaultBackground="require('@/assets/images/dataAgent/核心优势_bj_image@2x.jpg')"
          />
        </div>

        <!-- 智慧网银 -->
        <div class="" v-if="val == '5'">
          <ModelBox
            key="hx1"
            val="2"
            :claWidth="claWidth"
            :modelBox="modelBox4"
            mainTitle="核心功能"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showButton="false"
            :enableImageScale="false"
            :backgroundImage="require('@/assets/images/EcoAIBigData/hexingongneng_bj_image@2x.jpg')"
          >
          </ModelBox>
        </div>

        <!-- ai报账 -->
        <div class="" v-if="val == '6'">
          <FeatureCards
            :cards="modelBox[val - 1]"
            :columnsPerRow="4"
            :showTitle="true"
            :showMainTitle="true"
            :showSubTitle="true"
            :mainTitle="titleList[val - 1].mainTitle"
            :subTitle="Bannerlist[val - 1][0].title2"
            cardGap="20px"
            cardHeight="280px"
            :defaultBackground="require('@/assets/images/dataAgent/核心优势_bj_image@2x.jpg')"
          />
        </div>

        <div v-if="val == '6'" class="product-display-bg" style="top: 0">
          <div class="container">
            <div class="fs-1 fw-bold text-center mt-lyd-70">产品展示</div>
            <div class="fs-3 text-center lyd-title-colo1 subjtitle">{{ Bannerlist[val - 1][0].title2 }}</div>

            <div class="product-showcase-container">
              <img src="@/assets/images/dataAgent/AI报账_image@2x.png" class="aishenhe animate__animated" alt="AI报账" data-aos="fade-in" />
            </div>
          </div>
        </div>
        <div class="dtysmodel" v-if="val == '6'">
          <ModelBox
            key="hxys6"
            :uniqueId="'hxys6'"
            :val="1"
            :claWidth="claWidth"
            :modelBox="modelBox6"
            mainTitle="核心优势"
            :subTitle="Bannerlist[val - 1][0].title2"
            :showButton="false"
            :enableImageScale="false"
            :backgroundImage="require('@/assets/images/EcoAIBigData/hexinyoushi_bj_image@2x.jpg')"
          >
          </ModelBox>
        </div>
      </div>
    </div>
    <div class="order-show" v-if="shows">
      <order-show @close="close"></order-show>
    </div>
    <div class="demoAi" v-if="showDemo">
      <div class="demoAi-content">
        <i class="bi bi-x-lg search_header" @click="showDemo = false"></i>
        <img src="@/assets/images/dataAgent/机器人悬浮窗_image@2x.png" alt="" @click="goDemo()"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/common/Layout";
import StaticBanner from "@/components/common/staticBanner/index.vue";
import ListCard from "@/components/common/relatedCases/listCard";
import ModelBox from "@/components/common/counter/ModelBox.vue";
import dropdownMenu from "@/components/common/dropdownMenu.vue";
import FeatureCards from "@/components/common/FeatureCards.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import vueSeamlessScroll from "vue-seamless-scroll";
import OrderShow from "@/components/common/dialog/orderShow.vue";
import DeepseekRemoteDeploy from "@/components/common/DeepseekRemoteDeploy.vue";

export default {
  name: "CounterUpPage",
  components: {
    Layout,
    StaticBanner,
    ListCard,
    swiper,
    swiperSlide,
    ModelBox,
    vueSeamlessScroll,
    dropdownMenu,
    FeatureCards,
    OrderShow,
    DeepseekRemoteDeploy,
  },
  data() {
    return {
      deployData: {
        title: "Deepseek+企业级AI元生平台，多样化的应用部署模式",
        subtitle: "满足业务特性，成就企业梦想",
        description:
          "为大型企业提供灵活多样的部署方案，我们可以根据企业的实际需求，提供混合大模型管理、智能AI创新、数据隐私保护等多种部署模式，满足企业多元化的业务需求，为企业数字化转型提供强有力的技术支撑。",
        cards: [
          {
            title: "本地私有化部署",
            subtitle: "基于用户Deepseek",
            headerClass: "header-blue",
            mainTitle: "一体机私有化部署",
            features: ["开箱即用", "数据隐私", "本地安全"],
          },
          {
            title: "公有云部署",
            subtitle: "基于用户Deepseek",
            headerClass: "header-blue",
            mainTitle: "定制群件+应用广场+企业级AIAgent",
            features: ["更专业", "更敏捷", "更安全"],
          },
          {
            title: "混合云部署",
            subtitle: "灵活部署",
            headerClass: "header-blue",
            mainTitle: "大模型公有云+AI元生平台本地部署",
            features: ["灵活配置", "智能应用", "更便行"],
          },
        ],
      },
      featureCardsData: [
        {
          icon: require("@/assets/images/dataAgent/零代码开发-初始_icon_svg@2x.png"),
          icon1: require("@/assets/images/dataAgent/零代码开发-选中_icon_svg@2x.png"),
          title: "零代码开发",
          description: "用户无需掌握复杂的编程语言和代码编写技能，只需通过自然语言描述需求，平台就自动将需求转化为可执行的应用程序。",
          backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
          backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/多智能体协作-初始_svg@2x.png"),
          icon1: require("@/assets/images/dataAgent/多智能体协作-选中_svg@2x.png"),
          title: "多智能体协作",
          description: "平台内置多个智能体，每个智能体都有其特定的职责和功能",
          backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
          backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/多工具调用-初始_icon_svg@2x.png"),
          icon1: require("@/assets/images/dataAgent/多工具调用-选中_icon_svg@2x.png"),
          title: "多工具调用",
          description: "集成了多种实用工具，如数据库工具、API接口工具、数据分析工具等。",
          backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
          backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/快速生成应用-初始_icon_svg@2x.png"),
          icon1: require("@/assets/images/dataAgent/快速生成应用-选中_icon_svg@2x.png"),
          title: "快速生成应用",
          description: "从用户提出需求到生成可运行的应用，整个过程非常快速，最快仅需3分钟就能开发出一个应用。",
          backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
          backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
        },
      ],
      windowWidth: document.documentElement.clientWidth,
      Bannerlist: [
        [
          {
            bg: require("@/assets/images/dataAgent/Architecture_元生_image@2x.jpg"),
            title: "博信诚·AI元生平台",
            title2: "让企业经营管理更智能",
          },
        ],
        [
          {
            bg: require("@/assets/images/dataAgent/Architecture_DataAgent_image.png"),
            title: "Data Agent",
            title2: "让数据分析走向无人值守与智能响应，为企业构建可持续进化的决策中枢",
          },
        ],
        [
          {
            bg: require("@/assets/images/dataAgent/Architecture_审核_image@2x.png"),
            title: "AI审核",
            title2: "降本增效，智能风控",
          },
        ],
        [
          {
            bg: require("@/assets/images/dataAgent/AI合同审核.png"),
            title: "AI合同审核",
            title2: "智能高效，风险无忧",
          },
        ],
        [
          {
            bg: require("@/assets/images/dataAgent/智慧网易头部.jpg"),
            title: "智慧网银",
            title2: "重新定义企业资金管理，构建企业资金管控新引擎",
          },
        ],
        [
          {
            bg: require("@/assets/images/dataAgent/Architecture_报账_image@2x.png"),
            title: "AI报账",
            title2: "报销秒级完成，全程零人工",
          },
        ],
      ],
      companyall: [
        {
          logo: require("@/assets/images/home/anli/guolv.png"),
        },
        {
          logo: require("@/assets/images/home/anli/botian.png"),
        },
        {
          logo: require("@/assets/images/home/anli/zhiye.png"),
        },
        {
          logo: require("@/assets/images/home/anli/chinazh.png"),
        },
        {
          logo: require("@/assets/images/home/anli/luoyangzg.png"),
        },
        {
          logo: require("@/assets/images/home/anli/chinams.png"),
        },
        {
          logo: require("@/assets/images/home/anli/baoye.png"),
        },
        {
          logo: require("@/assets/images/home/anli/zl.png"),
        },
        {
          logo: require("@/assets/images/home/anli/enf.png"),
        },
        {
          logo: require("@/assets/images/home/anli/jingye.png"),
        },
        {
          logo: require("@/assets/images/home/anli/gangzhonglv.png"),
        },
        {
          logo: require("@/assets/images/home/anli/meinuo.png"),
        },
        {
          logo: require("@/assets/images/home/anli/zhongguojingye.png"),
        },
        {
          logo: require("@/assets/images/home/anli/dutyzero.png"),
        },
        {
          logo: require("@/assets/images/home/anli/19.png"),
        },
        {
          logo: require("@/assets/images/home/anli/guoyao.jpg"),
        },
        {
          logo: require("@/assets/images/home/anli/enfeihuaibao.png"),
        },
        {
          logo: require("@/assets/images/home/anli/huiruizhiyao.gif"),
        },
        {
          logo: require("@/assets/images/home/anli/nbtm.png"),
        },
        {
          logo: require("@/assets/images/home/anli/boe.png"),
        },
        {
          logo: require("@/assets/images/home/anli/shandongjingmi.png"),
        },
        {
          logo: require("@/assets/images/home/anli/rsms.png"),
        },
        {
          logo: require("@/assets/images/home/anli/nanjyy.png"),
        },
        {
          logo: require("@/assets/images/home/anli/xinlvyao.png"),
        },
        {
          logo: require("@/assets/images/home/anli/wuhanshizhongxinyiy.png"),
        },
        {
          logo: require("@/assets/images/home/anli/aolinteyaoye.png"),
        },
      ],
      demoClass: "col-lg-3 col-md-6 col-12",
      val: "",
      claWidth: "col-lg-6",
      groupData: [
        [
          {
            topTitle: "博信诚AI元生平台",
            text: "博信诚基于Deepseek满血增强版、通义千问等大模型，构建企业级AI大模型一站式元生平台，以诸多大模型基础，基于云原生分布式计算架构的AI低代码开发套件支持多种主流AI深度学习框架的可视化开发，允许用户设计和构建各种AI算法和模型，并通过提供便捷的开发环境、丰富的功能组件和高性能的算力资源帮助企业构建各类高效构建高精度的AI应用。",
            img1: require("@/assets/images/dataAgent/JGArchitecture_元生_image@2x.png"),
            img2: "",
          },
        ],
        [
          {
            topTitle: "Data Agent",
            text: "博信诚元生DataAgent是融合AI智能体、知识图谱与多Agent协同架构的下一代数据智能平台，具备端到端的数据闭环处理能力，让数据不仅能被“看见”，更能被“理解”和“执行”。无论是金融风控、零售运营、制造优化，还是医疗决策，DataAgent都能基于行业知识与企业特性，自动完成数据采集、清洗、分析、洞察乃至策略推荐的全过程，并通过多个智能体的高效协作，实现无人值守、实时响应、持续进化的智能决策体验。",
            img1: require("@/assets/images/dataAgent/JGArchitecture_DataAgent_image.png"),
            img2: "",
          },
        ],
        [
          {
            topTitle: "AI审核",
            text: "通过AI智能技术实现会计审核全流程自动化，涵盖从智能填单、AI审核到智能记账的一站式、端到端解决方案，可助力企业提升审核记账的完整性、准确性、时效性以及财务风险控制的有效性，实现降本增效，智能风控。",
            img1: require("@/assets/images/dataAgent/JGArchitecture_审核_image@2x.png"),
            img2: "",
          },
        ],
        [
          {
            topTitle: "AI合同审核",
            text: "AI合同审核是利用人工智能技术，专门设计用于自动化和智能化审核企业合同文件的软件应用。",
            text2:
              "它结合了机器学习、自然语言处理（NLP）、大数据分析等先进技术，能够快速、准确地识别合同中的关键条款、潜在风险点，并提供修改和优化建议。",
            img1: "",
            img2: "",
          },
        ],
        [
          {
            topTitle: "智慧网银",
            text: "智慧网银通过先进的智能化工具，（RPA）和人工智能（AI），为企业提供全面的银行业务自动化处理解决方案。",
            img1: require("@/assets/images/dataAgent/JGArchitecture_网银_image@1x.png"),
            img2: "",
          },
        ],
        [
          {
            topTitle: "AI报账",
            text: "博信诚AI报账通过Agent，实现AI报账精准赋值，将填单人事前申请需要手工填写的内容降至最低，大大提升了事前申请的填单体验。基于数据算法与行业实践AI报账实现智能分类与自动审核，单据处理时间从分钟级缩短至秒级。",
            img1: require("@/assets/images/dataAgent/JGArchitecture_报账_image@2x.png"),
            img2: "",
          },
        ],
      ],
      shows: false,
      titleList: [
        {
          mainTitle: "核心优势",
          subTitle: "赋能业务增长、成就企业梦想",
        },
        {
          mainTitle: "核心价值",
          subTitle: "赋能业务增长、成就企业梦想",
        },
        {
          mainTitle: "核心功能",
          subTitle: "赋能业务增长、成就企业梦想",
        },
        {
          mainTitle: "核心价值",
          subTitle: "赋能业务增长、成就企业梦想",
        },
        {
          mainTitle: "核心功能",
          subTitle: "赋能业务增长、成就企业梦想",
        },
        {
          mainTitle: "核心功能",
          subTitle: "赋能业务增长、成就企业梦想",
        },
      ],
      columnsPerRowList: [4, 4, 4, 4, 3, 4],
      modelBox6: [
        [
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "效率提升",
            title2:
              "传统手工报账需要大量人工录入和审核耗时较长且容易出错，而AI报账系统可以在几秒内完成报销单据的处理，显著缩短了报销周期，可将原本需要10个工作日完成的报账缩短至最快5分钟。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "数据分析能力",
            title2: "AI能够对海量财务数据进行分析，帮助企业发现费用支出的异常趋势，并提出优化建议",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "准确性提高",
            title2: "AI技术减少了人为输入错误的可能性，例如数字录入错误或报销类目的选择错误。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "用户体验改善",
            title2: "通过自然语言对话或语音输入，员工可以更便捷地提交报销申请，同时AI客服还可以提供即时解答，提升员工满意度。",
          },
        ],
      ],
      modelBox4: [
        [],
        [
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "自动化操作全面升级收付款认领",
            title2:
              "智能Agent自动完成银行流水、回单、余额查询等基础工作，效率提升十倍以上，人工干预几乎为零；企业收付数据的与流水唯一管理来源节点，信息自动下载，通过认领自动生成收款、付款单据，自动带出对方单位、对方账户、收款账户、金额、用途等关键信息",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "实时业务监控与反馈",
            title2: "",
            contionLIst: [
              "1.余额全账户监控：通过智能Agent，所有资金流动数据实时更新，确保企业随时掌握最新动态，通过智慧网银通道下载后的余额，统一归口管理，根据全级次、单组织、单账号查询账户余额情况。",
              "2.流水全账户监控：通过智慧网银通道下载后的银行交易流水并包含验重及补充机制，统一归口管理，可根据全级次、单组织、单账号查询账户交易情况，可按月与对账单进行自动核对",
            ],
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "电子回单统一管理",
            title2:
              "通过OCR及NLP自动解析版式文件，支持对各大银行不同版式回单进行识别，并结构化返回关键字段识别结果，能够满足对不同样式银行回单进行信息提取的需求形成电子回单结构化信息，支持筛选查看，电子版自动导入系统。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "智能Agent签收",
            title2: "",
            contionLIst: [
              "1.票据统一签收平台：通过智慧网银通道进行多银行多账户待签收票据的下载，统一归口界面查询及签收，自动完成网银相关签收审核动作并联动业务实现票据收款等业务的驱动。",
              "2.票据风险预警：通过智慧网银票据管理平台实现对于票据数据的统一归口台账管理，并对票据风险进行实时监控，包括黑名单单位、到期票提前自动预警等。",
            ],
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "智能对账与数据匹配",
            title2: "银行流水自动对账出具余额调节表，通过流水与单据的关联，未关联差异数据展示，自动出具银行调节表。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "多银行账户尽在掌中，智能登录",
            title2: "U盾柜最多可支持上百个U盾集中托管;支持机柜本地部署（需开放远程访问IP端口）提供托管U盾本地化权限分级管理功能",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "多维度资金数据分析监控",
            title2:
              "建立贯穿业务至资金端的分析机制，实现资金分析场景化、动态化和智能化，稳抓资金管理效果，实现资金管控可视，赋能业务及时风险预警，结合预实分析，提升资金预测效益。",
          },
        ],
      ],
      modelBox3: [
        [
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "降本增效",
            title2:
              "将文档审核时间从平均5-7天锐减至2小时内，实现审核流程的极速优化。大幅削减人力投入，据精准估算，人工审核成本可降低40%-60%，为企业带来显著的成本效益。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "财务数据结构化",
            title2: "将财务数据100%结构化，为财务分析模块形成管理量化支撑，为其它智能化产品提供数据基础，提供高质量的数据资产",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "推动财务标准化体系落地",
            title2:
              "释放人力低价值工作时间80%，推动与学历知识相匹配的工作内容设计，提升财务作业价值。推动财务标准化体系落地，形成标准化-智能化-更多标准化-更多智能化的良性循环。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "提高财务风险管控能力",
            title2:
              "实现财务初审的工作100%替代，也为共享复审、资金支付的审核要点和共享稽核的工作重点提供风险预警，满足后续数据分析和风险管理需求，提高财务风险管控能力。",
          },
        ],
      ],
      modelBox2: [
        [
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "自主闭环能力：从数据到决策的全链路自动化",
            title2:
              "DataAgent具备端到端的数据处理能力，能够自动完成数据采集、清洗、分析、洞察和可视化全流程。每个Agent可独立执行复杂任务，无需人工干预，实现真正的“无人值守”数据分析。通过模型优化与知识图谱的结合，确保分析结果不仅准确，还能直接转化为业务行动指南。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "多Agent协同：智能协作提升整体效率",
            title2:
              "支持多个DataAgent并行协作，不同Agent可以分工处理不同模块，并实时共享信息。通过统一语言系统进行跨团队、跨部门的信息传递，避免传统工作流中的沟通损耗。在协同过程中，Agent们持续积累经验，形成企业专属的知识资产库，不断增强组织的长期竞争力和适应性。",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "高度定制化：融合行业知识与企业特性",
            title2:
              "DataAgent不仅仅依赖通用大模型，还深度融合行业特定知识库和企业内部规则，为客户提供高度定制化的解决方案。根据不同的业务场景快速适配，满足金融、零售、制造、医疗等多行业的复杂需求。结合历史数据与实时动态，DataAgent帮助企业构建个性化的预测模型和策略推荐系统，精准贴合企业的战略目标和发展需求",
          },
        ],
      ],
      modelBox1: [
        [
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "数据驱动的全链路解决方案",
            title2:
              "DataAgent通过智能化、自动化的全新范式，打破传统局限，结合先进模型技术、行业知识图谱与深度定制能力，实现了从数据洞察到业务落地的全链路闭环。无论是实时分析、智能预警，还是策略推荐、流程优化，都能精准响应企业复杂多变的业务场景，真正释放数据资产的价值潜能",
          },
          {
            img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
            title1: "单点任务的深度执行，做您“全天候在线的数据顾问”",
            title2:
              "每个Data Agent能够独立完成特定数据分析任务（例如市场洞察、销售预测、竞品分析等），具备完整的工作链条：采集→整理→分析→洞察→呈现。相比传统人力方式，效率更高，7x24小时持续运作，逻辑严谨且具备高度可复用性。",
          },
        ],
      ],
      modelBox: [
        [
          {
            icon: require("@/assets/images/dataAgent/零代码开发-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/零代码开发-选中_icon_svg@2x.png"),
            title: "零代码开发",
            description: "用户无需掌握复杂的编程语言和代码编写技能，只需通过自然语言描述需求，平台就自动将需求转化为可执行的应用程序。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/多智能体协作-初始_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/多智能体协作-选中_svg@2x.png"),
            title: "多智能体协作",
            description: "平台内置多个智能体，每个智能体都有其特定的职责和功能",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/多工具调用-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/多工具调用-选中_icon_svg@2x.png"),
            title: "多工具调用",
            description: "集成了多种实用工具，如数据库工具、API接口工具、数据分析工具等。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/快速生成应用-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/快速生成应用-选中_icon_svg@2x.png"),
            title: "快速生成应用",
            description: "从用户提出需求到生成可运行的应用，整个过程非常快速，最快仅需3分钟就能开发出一个应用。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
        ],
        [
          {
            icon: require("@/assets/images/dataAgent/决策跃迁-初始_icon@2x.png"),
            icon1: require("@/assets/images/dataAgent/决策跃迁-选中_icon@2x.png"),
            title: "决策跃迁",
            description: "从“基于经验”到“基于实时智能”高效支撑企业重大决策。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/全局透视-初始_icon@2x.png"),
            icon1: require("@/assets/images/dataAgent/全局透视-选中_icon@2x.png"),
            title: "全局透视",
            description: "打破部门壁垒，形成企业级数据全景，洞察经营全貌。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/成本直降-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/成本直降-选中_icon_svg@2x.png"),
            title: "自主演进",
            description: "通过多Agent协同与自学习机制，让数据分析越来越精准。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/全球合规-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/全球合规-选中_icon_svg@2x.png"),
            title: "安全可信",
            description: "企业级数据治理与隐私保护，确保价值释放的同时绝对安全。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
        ],
        [
          {
            icon: require("@/assets/images/dataAgent/自动化配置-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/自动化配置-选中_icon_svg@2x.png"),
            title: "规则自动化配置",
            description:
              "对各种审批请求（费用单、合同、发票等）进行第一时间扫描，判定是否符合常规标准或企业合规政策；普通合规单据可直接建议“快速通过”，减少人工检查量。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/异常风险-选中_icon_svg@2x(1).png"),
            icon1: require("@/assets/images/dataAgent/异常风险-选中_icon_svg@2x.png"),
            title: "异常检测与风险识别",
            description:
              "利用机器学习算法，结合历史数据与行为模式识别重复报销、虚假发票、超预算申请等异常；一旦发现可疑线索，自动标注“高风险单据”，推送财务或管理人员二次复核。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/数据核验-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/数据核验-选中_icon_svg@2x.png"),
            title: "跨系统数据核验",
            description:
              "对接业务系统（ERP、CRM、项目管理）和财务系统，自动比对对应信息（预算额度、供应商、合同条款等）多维度检验单据真实性和一致性，及时发现数据不符或缺失",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/策略匹配-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/策略匹配-选中_icon_svg@2x.png"),
            title: "动态合规策略匹配",
            description:
              "对大部分“低风险”或“常规”单据给出“通过”建议，对“高风险”自动升级审批，进一步减少人为判断失误；通过学习人工纠正或二次审批的案例，AI持续优化审核策略，越用越精准。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/智能审批-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/智能审批-选中_icon.png"),
            title: "审批建议&自学习",
            description:
              "将企业财务制度、业务政策、法规要求封装成可执行的审核策略；如有新规定（差旅标准、报销上限等），可快速更新，AI由新规则驱动，无需手工修改大量逻辑。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/可视化报表-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/可视化报表-选中_icon_svg@2x.png"),
            title: "审计留痕与可视化报表",
            description:
              "AI审核过程（风险评分、原因分析）全程留痕，便于内外部合规与审计；管理层可随时查看审核效率统计、风险趋势、常见问题等可视化报告，做到心中有数。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
        ],
        [
          {
            icon: require("@/assets/images/dataAgent/快速生成应用-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/快速生成应用-选中_icon_svg@2x.png"),
            title: "秒级速审",
            description: "百页合同，10秒完成，效率提升10倍。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/精准控险-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/精准控险-选中_icon.png"),
            title: "精准控险",
            description: "AI识别隐藏条款，风险漏检率＜1%。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/成本直降-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/成本直降-选中_icon.png"),
            title: "成本直降",
            description: "替代80%+人工审查，单份合同成本从千元降至百元。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/全球合规-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/全球合规-选中_icon.png"),
            title: "全球合规",
            description: "内置多国法规库，跨境合同一键适配。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
        ],
        [],
        [
          {
            icon: require("@/assets/images/dataAgent/自动识别-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/自动识别-选中_icon.png"),
            title: "自动识别与分类",
            description: "通过OCR和自然语言处理技术，AI可以自动识别发票、收据等财务文件中的关键信息如金额、日期、供应商名称等，并将其分类归档。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/智能审批-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/智能审批-选中_icon.png"),
            title: "智能审批",
            description: "基于机器学习算法，AI能够自动判断报销单据是否符合企业的财务标准，从而减少人工审核的工作量。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/异常预警-初始_icon.png"),
            icon1: require("@/assets/images/dataAgent/异常风险-选中_icon_svg@2x(1).png"),
            title: "异常检测与预警",
            description: "AI系统能够分析大量报账数据，识别出异常模式和潜在风险，并及时发出警报，帮助企业降低财务欺诈风险。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
          {
            icon: require("@/assets/images/dataAgent/可视化报表-初始_icon_svg@2x.png"),
            icon1: require("@/assets/images/dataAgent/可视化报表-选中_icon_svg@2x.png"),
            title: "实时监控与预算分析",
            description: "AI可以实时监控费用支出情况，并根据历史数据生成预算报告，为企业提供精准的费用管理建议。",
            backgroundImage: require("@/assets/images/dataAgent/卡片初始背景_image@2x.png"),
            backgroundImage1: require("@/assets/images/dataAgent/卡片-选中背景_image@2x.png"),
          },
        ],

        // [{
        // 	img: require("@/assets/images/portfolio/eec/two-blue.png"),
        // 	title1: "智能合同管理",
        // 	title2: "智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理",
        // }],
        // [{
        // 	img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
        // 	title1: "进项管理",
        // 	title2: "进项管理实现发票采集、价税分离、报账、专票抵扣勾选、统计签名、进项转出等税务业务处理，系统出具抵扣明细及汇总表",
        // }, ],
        // [{
        // 		icon: require('@/assets/images/dataAgent/秒级速审-初始_icon.png'),
        // 		icon1: require('@/assets/images/dataAgent/秒级速审-选中_icon.png'),
        // 		title: '秒级速审',
        // 		description: '百页合同，10秒完成，效率提升10倍。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/卡片-选中背景_image@2x.png')
        // 	},
        // 	{
        // 		icon: require('@/assets/images/dataAgent/精准控险-初始_icon.png'),
        // 		icon1: require('@/assets/images/dataAgent/精准控险-选中_icon.png'),
        // 		title: '精准控险',
        // 		description: 'AI识别隐藏条款，风险漏检率＜1%。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/卡片-选中背景_image@2x.png')
        // 	},
        // 	{
        // 		icon: require('@/assets/images/dataAgent/成本直降-初始_icon.png'),
        // 		icon1: require('@/assets/images/dataAgent/成本直降-选中_icon.png'),
        // 		title: '成本直降',
        // 		description: '替代80%+人工审查，单份合同成本从千元降至百元。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/卡片-选中背景_image@2x.png')
        // 	},
        // 	{
        // 		icon: require('@/assets/images/dataAgent/全球合规-初始_icon.png'),
        // 		icon1: require('@/assets/images/dataAgent/全球合规-选中_icon.png'),
        // 		title: '全球合规',
        // 		description: '内置多国法规库，跨境合同一键适配。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/卡片-选中背景_image@2x.png')
        // 	},
        // ],
        // [{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '自动化操作全面升级收付款认领',
        // 		description: '智能Agent自动完成银行流水、回单、余额查询等基础工作，效率提升十倍以上，人工干预几乎为零；企业收付数据的与流水唯一管理来源节点，信息自动下载，通过认领自动生成收款、付款单据，自动带出对方单位、对方账户、收款账户、金额、用途等关键信息',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '实时业务监控与反馈',
        // 		description: '1.余额全账户监控：通过智能Agent，所有资金流动数据实时更新，确保企业随时掌握最新动态，通过智慧网银通道下载后的余额，统一归口管理，根据全级次、单组织、单账号查询账户余额情况。2.流水全账户监控：通过智慧网银通道下载后的银行交易流水并包含验重及补充机制，统一归口管理，可根据全级次、单组织、单账号查询账户交易情况，可按月与对账单进行自动核对',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '电子回单统一管理',
        // 		description: '通过OCR及NLP自动解析版式文件，支持对各大银行不同版式回单进行识别，并结构化返回关键字段识别结果，能够满足对不同样式银行回单进行信息提取的需求形成电子回单结构化信息，支持筛选查看，电子版自动导入系统。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '智能Agent签收',
        // 		description: '1.票据统一签收平台：通过智慧网银通道进行多银行多账户待签收票据的下载，统一归口界面查询及签收，自动完成网银相关签收审核动作并联动业务实现票据收款等业务的驱动。2.票据风险预警：通过智慧网银票据管理平台实现对于票据数据的统一归口台账管理，并对其风险进行实时监控，包括黑名单单位、到期票提前自动预警等。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '智能对账与数据匹配',
        // 		description: '银行流水自动对账出具余额调节表，通过流水与单据的关联，未关联差异数据展示，自动出具银行调节表。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '多银行账户尽在掌中，智能登录',
        // 		description: 'U盾柜最多可支持上百个U盾集中托管;支持机柜本地部署（需开放远程访问IP端口）提供托管U盾本地化权限分级管理功能',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	},
        // 	{
        // 		icon: '',
        // 		icon1: '',
        // 		title: '多维度资金数据分析监控',
        // 		description: '建立贯穿业务至资金端的分析机制，实现资金分析场景化、动态化和智能化，稳抓资金管理效果，实现资金管控可视，赋能业务及时风险预警，结合预实分析，提升资金预测效益。',
        // 		backgroundImage: require('@/assets/images/dataAgent/卡片初始背景_image@2x.png'),
        // 		backgroundImage1: require('@/assets/images/dataAgent/xuanzhong-bg.png')
        // 	}

        // ],
        // [{
        // 		img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
        // 		title1: "进项管理",
        // 		title2: "进项管理实现发票采集、价税分离、报账、专票抵扣勾选、统计签名、进项转出等税务业务处理，系统出具抵扣明细及汇总表",
        // 	},
        // 	{
        // 		img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
        // 		title1: "销项管理",
        // 		title2: "销项管理实现开票申请，开票流程管理、开票限额拆分、余票管理，单张及批量开票、发票作废、发票冲红、发票打印等",
        // 	},
        // 	{
        // 		img: require("@/assets/images/dataAgent/xuanzhong-bg.png"),
        // 		title1: "申报管理",
        // 		title2: "系统支持全税种申报，可以依据企业性质选择报表。系统分为纳税申报、涉税查询、申报作废三大模块",
        // 	},
        // ],
        // [{
        // 		img: require("@/assets/images/portfolio/eec/1.png"),
        // 		title1: "智能报表",
        // 		title2: "智能报表支持在多会计准则、多币种、法定及管理多组织架构等各种复杂环境下准确、自动生成报表。",
        // 	},
        // 	{
        // 		img: require("@/assets/images/portfolio/eec/1.png"),
        // 		title1: "智能分析管理",
        // 		title2: "智能分析通过业财数据中台，为企业过去、评价企业现状、预测企业未来做出正确决策提供准确的信息和依据。",
        // 	},
        // ],
      ],
      dataList: [
        {
          icon: require("@/assets/images/dataAgent/战略级场景_角标_image@2x.png"),
          title: "智能预测行业趋势",
          description: "评估战略选择方案风险收益，CEO的“第二大脑”",
          backgroundImage: require("@/assets/images/dataAgent/战略级场景_产品图_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/财务级场景_角标_image@2x.png"),
          title: "实时现金流预测",
          description: "智能成本管控、自动合规报告",
          backgroundImage: require("@/assets/images/dataAgent/财务级场景_产品图_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/运营级场景_角标_image@2x.png"),
          title: "从供应链到销售",
          description: "自动发现效率瓶颈与增长机会",
          backgroundImage: require("@/assets/images/dataAgent/运营级场景_产品图_image@2x.png"),
        },
        {
          icon: require("@/assets/images/dataAgent/风险级场景_角标_image@2x.png"),
          title: "自动扫描异常指标",
          description: "提前触发预警，降低经营黑天鹅事件",
          backgroundImage: require("@/assets/images/dataAgent/风险级场景_产品图_image@2x.png"),
        },
      ],
      showDemo: false,
    };
  },
  created() {
    this.valType();
  },
  computed: {
    defaultOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  watch: {
    $route() {
      this.valType();
    },
    // 监听val变化
    val(newVal, oldVal) {
      if (newVal == '2') {
        this.showDemo = true;
      }
    }
  },
  mounted() {
    console.log("页面实时宽度", this.windowWidth);
    console.log(this.Swiper);
    if (this.val == '2') {
      this.showDemo = true;
    }
  },
  methods: {
    slideChangeTransitionStartHandle() {
      let swiper = this.$refs.Swipers.swiper ? this.$refs.Swipers.swiper.realIndex : 0;
      for (let i = 1; i < 5; i++) {
        let ids1 = i + "1";
        let ids2 = i + "2";
        if (document.getElementById(ids1).getAttribute("class").indexOf("line") != -1) {
          document.getElementById(ids1).classList.remove("line");
        }
        if (document.getElementById(ids2).getAttribute("class").indexOf("content") != -1) {
          document.getElementById(ids2).classList.remove("content");
        }
      }
      for (let i = 1; i < Number(swiper) + 2; i++) {
        let ids1 = i + "1";
        let ids2 = i + "2";
        document.getElementById(ids1).classList.add("line");
        document.getElementById(ids2).classList.add("content");
        // document.getElementById(ids1).setAttribute("class", "line")
        // document.getElementById(ids2).setAttribute("class", "content")
      }
    },
    goTitle(val) {
      this.$router.push({
        path: "/dataAgent/" + val,
      });
      this.val = val;
    },
    valType() {
      this.val = this.$route.params.type;
    },
    goRouter() {
      this.$router.push({
        path: "/call-us",
      });
    },
    orderShow() {
      this.shows = true;
    },
    close() {
      this.shows = false;
    },

    title(val) {
      this.$router.push({
        path: "/dataAgent/" + val,
      });
    },
    goDemo() {
      // 跳转 ai演示页面
      window.open("http://14.103.252.38:8080/ssc/ai/index.html#/approvalDemo", "_blank");
    }
  },
};
</script>

<style lang="scss">
.daraagent {
  .modelBoxss .bottom-list .moreBox .moreBoxImg3 {
    width: 100%;
    height: 200px;
  }
  .hxjzmodel {
    height: 568px;
    .modelBoxss {
      height: 100%;
    }
  }
}
.product-display-bg {
  overflow: hidden;
  background-image: url("../assets/images/dataAgent/产品展示_bj_image.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  // min-height: 65rem;
  min-height: 600px;
  width: 100%;
  position: relative;
  // top: -77px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: #12294f;
  padding-bottom: 60px;
  // padding: 60px 0;
}
.pcdsflex {
  display: flex;
  align-items: center;
}

.subjtitle {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 1.125rem;
  color: #5f6c81;
  line-height: 28px;
}

.subjtitleth {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 1.125rem;
  margin-top: 2rem;
  color: #344b70;
  text-align: center;
  line-height: 28px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-display-bg {
    top: 0;
    min-height: 30rem;
  }
  .hxjzmodel {
    height: 410px !important;
    overflow: auto;
  }
  .pcdsflex {
    display: block;
  }
}

/* 产品展示容器 */
.product-showcase-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 8rem auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.aishenhe {
  transform: scale(1.4) !important;
}

/* 主产品截图 */
.main-product-image {
  width: 100%;
  max-width: 800px;
  height: auto;
  object-fit: contain;
  z-index: 1;
  border-radius: 12px;
  transition: transform 0.3s ease;
  transform: scale(1.4);
}

.main-product-image:hover {
}

/* 浮动窗口基础样式 */
.floating-window {
  position: absolute;
  width: auto;
  height: auto;
  max-width: 280px;
  z-index: 10;
  border-radius: 8px;
  transition: all 0.8s ease;
  cursor: pointer;

  transform: scale(1.4);
}

/* 浮动窗口悬浮效果 */
.floating-window:hover {
  // transform: translateY(-8px) scale(1.05);
  // box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  // z-index: 15;
}

/* AI审核窗口定位 */
.ai-audit {
  bottom: -10%;
  left: 40%;
}

/* AI工作助理窗口定位 */
.ai-assistant {
  top: 5%;
  right: 8%;
}

/* AI报账窗口定位 */
.ai-reimbursement {
  top: 26%;
  left: 8%;
}
.dataAgentDiv {

  .dataAgent-cont {
    margin-top: 36px;
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
    .dataAgentItem {
      // width: 628px;
      // height: 518px;
      background: #ffffff;
      box-shadow: 0 0 28px 0 #3162ee1f;
      border-radius: 12px;
      padding: 30px 12px 12px;
      margin-bottom: 24px;
      transition: transform 0.3s ease;
      .dataAgent-top{
        margin-left:20px
      }
      .dataAgentIcon {
        img {
          width: 94px;
          height: 40px;
        }
      }
      .dataAgentTitle {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 18px;
        color: #12294f;
        line-height: 1.5;
      }
      .dataAgentBtn {
        width: fit-content;
        background: #f5fbff;
        border-radius: 4px;
        padding: 7px 20px;
        // 渐变边框
        border: 1px solid #3fb7f6;
        // border: 1px solid transparent;
        // border-image: linear-gradient(90deg, #3FB7F6 0%, #3060EE 100%);
        // border-image-slice: 1;

        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        font-size: 14px;
        color: #3060ee;
        margin: 22px 0;
      }
      .dataAgentImg {
        background-image: linear-gradient(-1deg, #3486fd38 0%, #7fdcfa17 49%, #ffffff38 95%);
        border-radius: 10px;
        img {
          width: 580px;
          height: 291px;
          @media (max-width: 768px) {
            width: 100%;
            height: 100%;
          }
        }
      }
      &:hover {
        transform: scale(1.01);
        border: 1px solid #3165EE;
        box-shadow: 0 0 28px 0 #3162ee5c;
        transition: transform 0.7s ease;
      }
    }
  }
}
.demoAi {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    // background: rgba($color: #999, $alpha: 0.9);
    .demoAi-content{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    img{
      width: 806px;
      height: 440px;
    }
    i{
      position: absolute;
      top: 70px;
      right: 80px;
      z-index: 999;
      font-size: 24px;
      color: #fff;
      cursor: pointer;
    }
}
@media (max-width: 768px) {
  .product-showcase-container {
    padding: 1rem;
    margin: 3rem auto;
  }

  .floating-window {
    max-width: 180px;
  }

  .ai-audit {
    bottom: -12%;
    left: 30%;
  }

  .ai-assistant {
    right: -4%;
    top: 2%;
  }

  .ai-reimbursement {
    bottom: 8%;
    left: -5%;
  }
}

@media (max-width: 480px) {
}
</style>
